import { useCallback, useState } from "react";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { useSnackbar } from "../../hooks/useSnackbar";
import useAuth from "../../routes/login/AuthContext";
import { putPlacementWorksheetSettingsUnitNumber } from "../../services/PlacementWorksheetApi";
import { usePlacementWorksheetTableRowContext } from "./PlacementWorksheetTableRowContext";

export const useUnitNumberHandler = (unitId: number, withNofitications = true) => {
  const { getAuthToken, isSuperAdminRead } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { l2Id, l3Id, updateUnitNumber } = usePlacementWorksheetContext();
  const { setIsFinished } = usePlacementWorksheetTableRowContext();
  const { showErrorSnackbar } = useSnackbar();

  const updateHandler = useCallback(
    async (unitNumber: string) => {
      if (!l2Id || !l3Id || isSuperAdminRead()) return;

      setIsLoading(true);

      try {
        const token = await getAuthToken();

        const res = await putPlacementWorksheetSettingsUnitNumber(
          selectedNetworkId,
          l2Id,
          l3Id,
          unitId,
          unitNumber,
          token
        );

        const { error } = res;

        if (!!error) {
          if (withNofitications) {
            showErrorSnackbar(error.description);
          }
          return;
        }

        updateUnitNumber(unitId, unitNumber);

        setIsFinished(true);
      } catch (err) {
        if (withNofitications) {
          showErrorSnackbar();
        }
      }
      setIsLoading(false);
    },
    [selectedNetworkId, l2Id, l3Id, unitId]
  );

  return {
    isLoading,
    updateHandler,
  };
};
